import { render, staticRenderFns } from "./pageOption.vue?vue&type=template&id=60251c78&"
import script from "./pageOption.vue?vue&type=script&lang=js&"
export * from "./pageOption.vue?vue&type=script&lang=js&"
import style0 from "./pageOption.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports